import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { IDataPoint } from './datapoints-data.service';
import { LevelAsset } from './assets-data.service';
import { OfflineEvent } from './events-data.service';

/**
 * Interface for Database Account Object
 * @help
 * let account = this.accounts.find(({ id }) => id === "<ID String>")
 */
export interface IIntegratonSensor {
	/** Sensor ID */
	SensorID: number
	/** Sensor ID */
	WebhookSensorID: number
	/** Sensor Public ID */
	PublicSensorID: string
	/** Sensor Name */
	Name: string
	/** Sensor Description */
	Description: string
	/** Sensor Image URL */
	ImageURL: string
	/** Sensor Webhook ID */
	WebhookID: number
	/** Sensor Enabled */
	Enabled: boolean
	/** Sensor Offline */
	Offline: boolean
	/** Sensor Modified Epoch */
	Modified: number
	/** Sensor Datapoints */
	Datapoints: IDataPoint[]
	/* Last Value Received Epoch */
	LastValueReceived: number
	/** Enable Offline Notifications*/
	EnableOffline: boolean;
	/** Linked Assets */
	LinkedAssets: LevelAsset[];
	/** Offline History */
	OfflineHistory: OfflineEvent[];
	/** Is Cumulative */
	isCumulative: boolean;
	/** Is Neuron Sensor */
	NeuronSensors: boolean;


	/** Optional Selected Property used purly for GUI */
	_Selected?: boolean;
}

/**
 * IntegrationSensorsService
 */
@Injectable({
	providedIn: 'root'
})
export class IntegrationSensorsService {

	/** Enable Console Messages */
	private Debug: boolean = false

	/** Default Account */
	private defaultAccountSubject: BehaviorSubject<any>;

	/** Default Account for User (JSON FORMAT) */
	public defaultAccount$: Observable<string>;

	/**
	 * Log message to the Console
	 * @param str
	 */
	consoleLog(str: any) { if (this.Debug == true) console.log(str) }

	/** API Route */
	apiRoute: string = "api/{0}/organisation/{1}/Sensors"

	/**
	 * Default Constructor
	 * @param http Imports the 'HttpClient' Object for internet requests
	 * @param globalFunctions globalFunctions
	 */
	constructor(
		private http: HttpClient,
		private globalFunctions: GlobalFunctions
	) { }

	/**
	 * Service to return a list of Webhook Integration for this Organistion
	 * @param accountGUID Account GUID
	 * @param organisationID Organisadion UID
	   * @param integrationID Integration ID
	 * @param queryParams Optional Query Parameters
	 * @returns IntegrationSensor[] Array of Sensors
	 */
	getIntegrationSensors$(accountGUID: string, organisationID: string, integrationID: string, queryParams: {} = {}): Observable<any> {

		let url = this.apiRoute;
		url = url.replace("{0}", accountGUID);
		url = url.replace("{1}", organisationID);

		url = `${environment.apiUrl}/${url}/integration/${integrationID}`;
		return this.globalFunctions.fetchAPI(this.http, url, "GET", queryParams)
	}

	/**
	 * Service to return a list of Webhook Integration for this Organistion
	 * @param accountGUID Account GUID
	 * @param organisationID Organisadion UID
	 * @param integrationID Integrtion ID
	 * @param sensor sensor to patch
	 * @param queryParams Optional Query Parameters
	 * @returns IntegrationSensor[] Array of Sensors
	 */
	patchIntegrationSensor$(accountGUID: string, organisationID: string, integrationID: string, sensor: IIntegratonSensor): Observable<any> {

		let data = JSON.stringify(sensor);

		let url = this.apiRoute;
		url = url.replace("{0}", accountGUID);
		url = url.replace("{1}", organisationID);

		url = `${environment.apiUrl}/${url}/integration/${integrationID}/sensor/${sensor.SensorID}`;
		return this.globalFunctions.fetchAPI(this.http, url, "PATCH", data)
	}

	/**
	 * getIntegrationSensorDetails
	 * @param accountGUID accountGUID 
	 * @param organisationID organisationID 
	 * @param sensorID sensorID 
	 * @returns 
	 */
	getIntegrationSensorDetails$(accountGUID: string, organisationID: string, sensorID: number): Observable<any> {

		let url = this.apiRoute;
		url = url.replace("{0}", accountGUID);
		url = url.replace("{1}", organisationID);

		url = `${environment.apiUrl}/${url}/sensorDetails/${sensorID}`;
		return this.globalFunctions.fetchAPI(this.http, url, "GET", {})
	}
}
